import { Box, Button, Columns, Container, Content, Heading, Icon, Section, Tag } from 'react-bulma-components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageTitle from '../components/pagetitle';
import React from 'react';
import { colors } from '../styles';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { navigate } from '@reach/router';

const MONTHLY_PRICE = 15;
const YEARLY_PRICE = 150;
const YEARLY_SAVINGS = MONTHLY_PRICE * 12 - YEARLY_PRICE;

const FEATURES = [
  'Unlock every step of every song and Fact — not just the free first step',
  'Save songs and Facts to your personal library',
  'Support the musicians creating new content',
];

const FeatureList = () => (
  <Content style={{ textAlign: 'left', marginTop: '1.5rem' }}>
    <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
      {FEATURES.map(feature => (
        <li key={feature} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', marginBottom: '0.75rem' }}>
          <Icon><FontAwesomeIcon icon={faCheckCircle} color={colors.green} /></Icon>
          <span>{feature}</span>
        </li>
      ))}
    </ul>
  </Content>
);

const PricingPage = () => {
  return (
    <>
      <PageTitle name="Pricing" description="One plan. Everything included." />
      <Section>
        <Container>
          <Columns centered>
            <Columns.Column size={5}>
              <Box style={{ textAlign: 'center', height: '100%' }}>
                <Heading size={4}>Monthly</Heading>
                <Heading size={2} style={{ margin: '1rem 0' }}>
                  ${MONTHLY_PRICE}
                  <Heading subtitle size={6} renderAs="span"> / month</Heading>
                </Heading>
                <Content style={{ color: colors.textSecondary }}>
                  Billed every month, cancel any time.
                </Content>

                <FeatureList />

                <Button color="light" fullwidth size="medium" onClick={() => navigate('/contact')} style={{ marginTop: '1.5rem' }}>
                  Get in touch to subscribe
                </Button>
              </Box>
            </Columns.Column>

            <Columns.Column size={5}>
              <Box style={{ textAlign: 'center', height: '100%', border: `2px solid ${colors.primary}`, position: 'relative' }}>
                <Tag color="primary" style={{ position: 'absolute', top: '-0.75rem', left: '50%', transform: 'translateX(-50%)' }}>
                  Recommended — save ${YEARLY_SAVINGS}
                </Tag>
                <Heading size={4} style={{ marginTop: '0.5rem' }}>Yearly</Heading>
                <Heading size={2} style={{ margin: '1rem 0' }}>
                  ${YEARLY_PRICE}
                  <Heading subtitle size={6} renderAs="span"> / year</Heading>
                </Heading>
                <Content style={{ color: colors.textSecondary }}>
                  That's ${(YEARLY_PRICE / 12).toFixed(2)}/month, billed annually.
                </Content>

                <FeatureList />

                <Button color="primary" fullwidth size="medium" onClick={() => navigate('/contact')} style={{ marginTop: '1.5rem' }}>
                  Get in touch to subscribe
                </Button>
              </Box>
            </Columns.Column>
          </Columns>

          <Content style={{ color: colors.textSecondary, textAlign: 'center', marginTop: '1rem', fontSize: '0.85rem' }}>
            Self-service checkout is coming soon — for now, subscriptions are set up by hand.
          </Content>
        </Container>
      </Section>
    </>
  );
};

export default PricingPage;
